import React from 'react';
import Layout from '../components/Layout';
import HomePageContent from '../components/HomePageCard';

function HomePage() {

  return (
    <Layout videoUrl="https://burakgundogan.net/videos/3129671-uhd_3840_2160_30fps_hzqcf0.mp4">
      <HomePageContent />
    </Layout>
  );
}

export default HomePage;